import { EventEmitter } from 'events';

export class Realtime extends EventEmitter {
  private socket: WebSocket;
  constructor(channels: string[]) {
    super();
    this.socket = new WebSocket('wss://www.bitmex.com/realtime');
    this.socket.onopen = () => {
      this.socket.send(JSON.stringify({ op: 'subscribe', args: channels }));
    };
    this.socket.onmessage = (message: MessageEvent) => {
      const res = JSON.parse(message.data);
      switch (res.table) {
        case 'orderBookL2':
          this.emit('orderbook', res);
          break;
        case 'instrument':
          this.emit('instrument', res);
          break;
        case 'trade':
          this.emit('trade', res);
          break;
        default:
          break;
      }
    };
  }
}
